import {getDominantBlockType, withX, withType, getBlocks} from '../calculateRules.js';
import {doc} from './docs.js';
import {byX} from './utils.js';

doc(
    "append",
    {
        "blockNumber": "block to shift",
        "type": "type to append [ACCENT, PIANO, PIANISSIMO, REST, REGULAR, LEGATO, STACCATO]",
    },
    "Shifts a block in grid by 1 to the right"
);
export const append = (grid, blockNumber, type) => {
    let {cells, size} = grid;
    let blocks = getBlocks(cells, size);

    let block = blocks[blockNumber % blocks.length];
    if (!block || !type) {
        return;
    }
    
    let blockByX = byX(block);
    let xValues = Object.keys(blockByX).map(k => parseInt(k));
    let toInsert = {
        type,
        value: ''
    };

    let maxX = Math.max(... xValues);
    let {x,y} = blockByX[maxX][0];
    if (cells[y][x] === '-') {
        x++;
    }
    x++;
    grid.set(x,y,toInsert);
}

 
